import * as React from 'react';
import MaterialUIListSubheader, { ListSubheaderProps } from '@material-ui/core/ListSubheader';
import { Theme, withStyles, WithStyles } from '@material-ui/core/styles';

const styles = (theme: Theme) => ({
  root: {
    lineHeight: '40px',
    padding: `0 ${theme.spacing(1.5)}px`
  },
  inset: {
    paddingLeft: theme.spacing(7)
  }
});

type Props = WithStyles<typeof styles> & ListSubheaderProps;

const ListSubheaderComponent: React.FC<Props> = props => <MaterialUIListSubheader disableSticky {...props} />;

export const ListSubheader = withStyles(styles)(ListSubheaderComponent);
